module.exports = __webpack_public_path__ + "img/tick-dark-blue.d9485116.svg";